import { getApi, patchApi } from "./general.service";

/**
 * AI-generated content pending review (drafts).
 *
 * Backend contract (frozen, backend may not be running yet):
 *   GET   /admin/ai-content/drafts?type=card|deck&page=&take=&search=
 *         → { results: [...], pagination: {...} }  (same shape as GET /admin/deck)
 *   PATCH /admin/ai-content/:type/:id/approve
 *   PATCH /admin/ai-content/:type/:id/reject   body: { reason } (optional)
 */

export const getAiDrafts = async (type, params = {}) => {
  const query = new URLSearchParams();
  query.set("type", type);
  // Callers use 0-based pages (TablePagination, review queue); this API is 1-based.
  if (params.page !== undefined && params.page !== null) query.set("page", String(Number(params.page) + 1));
  if (params.take !== undefined && params.take !== null) query.set("take", String(params.take));
  if (params.search && String(params.search).trim()) query.set("search", String(params.search).trim());
  return getApi(`/admin/ai-content/drafts?${query.toString()}`);
};

export const approveAiDraft = async (type, id) => {
  return patchApi(`/admin/ai-content/${type}/${id}/approve`, {});
};

export const rejectAiDraft = async (type, id, reason, bugType) => {
  const body = {};
  if (reason) body.reason = reason;
  // bugType only applies to cards — the API auto-creates a Bug via the /bug system.
  if (bugType && type === "card") body.bugType = bugType;
  return patchApi(`/admin/ai-content/${type}/${id}/reject`, body);
};

// Exact values of the API's BugType enum
// (boost-api-v3/src/backoffice/bugs/domain/bug.dto.ts)
export const AI_BUG_TYPES = [
  "Translation",
  "AppError",
  "VideoMismatch",
  "WrongContextExample",
  "WordTranslationError",
  "Context1TransError",
  "Context2TransError",
  "PinyinError",
  "MissVideo",
];
